export default "__VITE_ASSET__CCI2EFsX__"